import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>
                <CheckboxInput
                    name="displayChart"
                    label={translate.gettext("Display chart")}
                    checked={settings.displayChart}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Display table")}
                    name="displayTable"
                    checked={settings.displayTable}
                    onChange={this.handleChange.bind(this)} />
                    
                <CheckboxInput
                    name="displaySystemsWithoutPm"
                    label={translate.gettext("Systems without PM")}
                    checked={settings.displaySystemsWithoutPm}
                    onChange={this.handleChange.bind(this)}
                />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    name="displayName"
                    label={translate.gettext("Name")}
                    checked={settings.displayName}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayScanState"
                    label={translate.gettext("Last scan state")}
                    checked={settings.displayScanState}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayInstallState"
                    label={translate.gettext("Last install state")}
                    checked={settings.displayInstallState}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayLastScanTime"
                    label={translate.gettext("Last scan date")}
                    checked={settings.displayLastScanTime}
                    onChange={this.handleChange.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listSystems/Editor.tsx